import { Currency, Token } from '@/sdk'
import { isAddress } from '@/utils'

export function normalizeTokenSearchQuery(value: string): string {
  const trimmed = value.trim()
  const checksummed = isAddress(trimmed)
  return checksummed || value
}

export function isTokenInPickerList(token: Token, knownTokens: readonly Currency[]): boolean {
  const lower = token.address.toLowerCase()
  return knownTokens.some(
    (currency) => currency instanceof Token && currency.address.toLowerCase() === lower,
  )
}

export function resolveImportableAddressSearch(
  search: string,
  searchToken: Token | null | undefined,
  knownTokens: readonly Currency[],
) {
  const checksummed = isAddress(search.trim())
  const isAddressSearch = Boolean(checksummed)
  const isResolvingAddress = isAddressSearch && searchToken === null
  const importedByAddress =
    isAddressSearch && searchToken instanceof Token
      ? !isTokenInPickerList(searchToken, knownTokens)
      : false
  const addressNotFound =
    isAddressSearch && !isResolvingAddress && searchToken === undefined

  return {
    isAddressSearch,
    isResolvingAddress,
    importedByAddress,
    addressNotFound,
  }
}
